module.exports = __webpack_public_path__ + "static/media/nica-logo.b256ee2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/nica-logo.svg
// module id = 388
// module chunks = 0